import { DRAFT } from 'actions/DraftActions'

function initialState() {
  return null
}

export default function draft(state = initialState(), action) {
  switch (action.type) {
    case DRAFT:
      return action.payload
    default:
      return state
  }
}
